import { BaseBlock } from "./BaseBlock";
import { LessonBlock } from "./LessonBlock";
import type { StateStore } from "../app/state/StateStore";

import type {
    CompletedProduct
} from "../app/state/AppState";

import type { Block } from "./Block";

export class ProductBlock extends BaseBlock {

    private readonly product: CompletedProduct;

    private readonly lessons: Block[] = [];

    private readonly store: StateStore;

    private root!: HTMLElement;

    constructor(
        product: CompletedProduct,
        store: StateStore,
        private readonly openKrok: (
            krokId: string
        ) => void
        ) {

        super();

        this.product = product;
        this.store = store;

    }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "sticker-card account-card list-product-card";

        const title =
            document.createElement("h3");

        title.textContent =
            this.product.product_title;

        this.root.appendChild(
            title
        );

        for (const lesson of this.product.lessons) {

            const block =
                new LessonBlock(
                    lesson,
                    this.store,
                    this.openKrok
                );

            this.lessons.push(
                block
            );

            block.mount();

            this.root.appendChild(
                block.getRoot()
            );

        }

    }

    public override update(): void {

        for (const lesson of this.lessons) {
            lesson.update();
        }

    }

    public override unmount(): void {

        for (const lesson of this.lessons) {
            lesson.unmount();
        }

        this.lessons.length = 0;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}